export const QUICK_AMOUNTS = [100, 500, 1000];

// OnRamper subscription is inactive: fiat rails (deposit via card, withdrawal via
// bank) stay visible but disabled. To re-enable, set
// NEXT_PUBLIC_ONRAMPER_PAYMENTS_ENABLED=true in the environment (or flip this to true).
export const ONRAMPER_PAYMENTS_ENABLED =
  process.env.NEXT_PUBLIC_ONRAMPER_PAYMENTS_ENABLED === 'true';

export const STATIC_COUNTRIES = [
  { code: 'US', name: 'United States' },
  { code: 'IN', name: 'India' },
  { code: 'GB', name: 'United Kingdom' },
  { code: 'CA', name: 'Canada' },
  { code: 'AU', name: 'Australia' },
  { code: 'MX', name: 'Mexico' },
  { code: 'BR', name: 'Brazil' },
  { code: 'DE', name: 'Germany' },
  { code: 'FR', name: 'France' },
  { code: 'JP', name: 'Japan' },
];
